<template lang="pug">
  div(style="height: 100%; overflow: hidden")
    v-row.ma-0.justify-center.pt-6(
      v-if="title"
      style="height: 20%")
      v-col.pa-0.d-flex.align-end.justify-center(:cols="12")
        h2.text-center.display-3 {{ title }}
      v-col.text-center.pa-0.mt-2(
        v-if="subtitle"
        :cols="12")
        span.grey--text {{ subtitle }}
    v-row.ma-0(:style="{ height: `${title ? 60 : 80}%` }")
      self-carousel(
        v-if="screens"
        :progress-override="progressOverride"
        :screens="screens")
    v-row.ma-0.px-4.align-center.justify-center(
      style="height: 20%")
      v-col(v-if="$slots.actions")
        slot(name="actions")
      v-col.text-center
        v-scale-transition(
          origin="center center 0"
          mode="out-in")
          v-btn(
            v-if="progressOverride > 0"
            @click="goPrevious"
            icon)
            v-icon {{ mdiChevronLeft }}
      v-col.text-center
        v-btn(
          @click="finish"
          color="primary") Commencer
      v-col.text-center
        v-scale-transition(
          origin="center center 0"
          mode="out-in")
          v-btn(
            v-if="progressOverride < $get(screens, `length`) - 1"
            @click="goNext"
            icon)
            v-icon {{ mdiChevronRight }}
</template>

<script>
import { ref } from '@vue/composition-api'
import SelfCarousel from './carousel/'
import { theme } from '@iez/core'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'

export default {
  components: {
    SelfCarousel
  },

  props: {
    title: String,
    screens: Array,
    subtitle: String
  },

  setup (props, { emit }) {
    const progressOverride = ref(0)

    const finish = () => {
      emit('finish')
    }

    const goNext = () => {
      progressOverride.value++
    }

    const goPrevious = () => {
      progressOverride.value--
    }

    return {
      finish,
      theme,
      mdiChevronLeft,
      mdiChevronRight,
      progressOverride,
      goNext,
      goPrevious
    }
  }
}
</script>
